import { service } from "@/ajax/request";
import { Id } from "@/types/common";
import { AxiosPromise } from "axios";
import {
  MemberInfo,
  MemberRebateList,
  MemberRebateListParams,
  UpdateDescription,
} from "@/types/api/vip";

export interface MemberList {
  enterStatus?:string|number;
  recentExpenseBeginTime?:string;
  recentExpenseEndTime?:string;
  cardType?:string;
  fromDate?: string;
  shopName?: string;
  phone?: string;
  userName?: string;
  enterCost?: number;
  toDate?: string;
  pageNum?: number;
  pageSize?: number;
  vip?: number;
  operationMemberId?:null|number;
  serviceId?:null|number;
  subCompanyId?:null|number;
}

export interface UserList {
  memberId?: number;
  status?: number;
  pageNum?: number;
  pageSize?: number;
}

// 获取会员列表
export const memberList = (params: MemberList): AxiosPromise =>
  service({
    url: `/member/list`,
    method: "GET",
    type: "form",
    params,
  });

// 修改入驻信息
export const memberUpdate = (params: MemberInfo): AxiosPromise =>
  service({
    url: `/member/update/${params.id}`,
    method: "POST",
    params,
  });

// 修改用户审核状态
export const updateVerifyStatus = (params: {
  id: number;
  status: number;
}): AxiosPromise =>
  service({
    url: `/member/updateVerifyStatus/${params.id}`,
    method: "POST",
    type: "form",
    params,
  });

// 获取用户详细信息
export const memberDetail = (params: { id: number }): AxiosPromise =>
  service({
    url: `/member/${params.id}`,
    method: "GET",
    type: "form",
  });

// 修改入驻信息（营业执照和门店照片） 根据用户id
export const updateShopImage = (params: {
  memberId: number;
  businessLicense?: string;
  shopImage?: string;
}): AxiosPromise =>
  service({
    url: `/member/updateShopImage/${params.memberId}`,
    method: "POST",
    params,
  });

// 提现列表 status:1->待审核 2>拒绝提款 3>审核通过
export const memberRebateList = (
  params: MemberRebateListParams
): AxiosPromise =>
  service({
    url: `/member/rebate/list`,
    method: "GET",
    params,
  });

// 修改用户审核状态审核状态 2>拒绝提款 3>审核通过
export const updateRebateStatus = (params: {
  id: number;
  status: number;
}): AxiosPromise =>
  service({
    url: `/member/update/rebateStatus/${params.id}`,
    method: "POST",
    params,
    type: "form",
  });


  // 修改用户是否直营，selfType 0：表示非直营 1：表示直营
export const updateSelfType = (params: any): AxiosPromise =>
service({
  url: `/member/updateSelfType/${params.id}`,
  method: "POST",
  type: "form",
  params: params
});

// 修改备注
export const updateDescription = (params: UpdateDescription): AxiosPromise =>
  service({
    url: `/member/updateDescription/${params.id}`,
    method: "POST",
    params: params.description,
  });

// 重置支付密码
export const resetPayPassword = (params: { id: number }): AxiosPromise =>
  service({
    url: `/member/resetPayPassword/${params.id}`,
    method: "POST",
    type: "form",
  });

// 根据用户ID获取交易统计信息
export const memberDeal = (params: { id: number }): AxiosPromise =>
  service({
    url: `/member/deal/${params.id}`,
    method: "GET",
    type: "form",
  });

// 获取用户详细信息包含用户门店信息
export const memberAndShop = (params: { id: number }): AxiosPromise =>
  service({
    url: `/member/memberAndShop/${params.id}`,
    method: "GET",
    type: "form",
  });

// 会员中心 邀请返利列表: status: 0-待到账返利, 1-已到账返利
export const rebateList = (params: UserList): AxiosPromise =>
  service({
    url: `/member/invite/rebateList`,
    method: "GET",
    type: "form",
    params,
  });

  // 会员中心 邀请推荐列表: status: 0-推广人数, 1-下单人数
export const recommendList = (params: UserList): AxiosPromise =>
service({
  url: `/member/invite/recommendList`,
  method: "GET",
  type: "form",
  params,
});


  // 用户列表统计客户信息
  export const memberCountInfo = (): AxiosPromise =>
  service({
    url: `/member/memberCountInfo`,
    method: "GET"
  });


    // 得到账户信息
    export const getAccountRecommendInfo = (params: { id: number }): AxiosPromise =>
    service({
      url: `/member/getAccountRecommendInfo/${params.id}`,
      method: "GET"
    });
  



    // 获取入驻待审核用户个数
    export const getCountVerifyStatus = (): AxiosPromise =>
    service({
      url: `/member/getCountVerifyStatus`,
      method: "GET"
    });
  
        // 获取今天游客数量
        export const getCountTodayMember = (): AxiosPromise =>
        service({
          url: `/member/getCountTodayMember`,
          method: "GET"
        });
      